import { render, staticRenderFns } from "./UniqueSellingPoints.vue?vue&type=template&id=b7887318"
import script from "./UniqueSellingPoints.vue?vue&type=script&lang=js"
export * from "./UniqueSellingPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports